import React from 'react';
import { Composition } from 'remotion';
import { CatBeruk } from './CatBeruk';

export const Root: React.FC = () => {
  return (
    <>
      <Composition
        id="CatBeruk"
        component={CatBeruk}
        durationInFrames={500}
        fps={30}
        width={1280}
        height={720}
        defaultProps={{}}
      />
    </>
  );
};
